<template>
  <EquipmentTable @show="showSuccess" />
</template>

<script>
import EquipmentTable from './components/equipmentTable/EquipmentTable.vue'

export default {
  components: {
    EquipmentTable,
  },

  methods: {
    showSuccess(message) {
      this.$emit('show', message)
    },
  },

  created() {},
}
</script>
